
import React, { useState, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';


const ConfigurationPage = () => {
  const [configurations, setConfigurations] = useState([]);
  const [selectedConfiguration, setSelectedConfiguration] = useState('');
  const [updatedConfiguration, setUpdatedConfiguration] = useState({});
  const[buttonName,setButtonName] = useState('Atualizar');


  const handleChangeOutPut = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => {
      const updatedConfig = {
        ...prevSelectedConfig,
        OutputData: e.target.value,
      };
      return updatedConfig;
    });
  };
  const handleChangeAdditionalConfiguration = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => ({
      ...prevSelectedConfig,
      AdditionalConfiguration: e.target.value,
    }));
  };
  
  const handleChangeStatus = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => ({
      ...prevSelectedConfig,
      Status: e.target.value,
    }));
  };
  
  const handleChangeCompanyID = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => ({
      ...prevSelectedConfig,
      CompanyID: e.target.value,
    }));
  };
  
  const handleChangeDescription = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => ({
      ...prevSelectedConfig,
      Description: e.target.value,
    }));
  };

  const handleChangeConfiguration = (e) => {
    setSelectedConfiguration((prevSelectedConfig) => ({
      ...prevSelectedConfig,
      Configuration: e.target.value,
    }));
  };

  // Função para carregar as configurações
  const loadConfigurations = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/configuration/getConfigurations');
      setConfigurations(JSON.parse(response.data.Value));
    } catch (error) {
      console.error('Error loading configurations:', error);
    }
  };

  // Função para atualizar a configuração
  const updateConfiguration = async () => {
    try {
      const formData = new FormData();
      formData.append('configuration', selectedConfiguration.Configuration);
      formData.append('outputData', selectedConfiguration.OutputData);
      formData.append('additionalConfiguration', selectedConfiguration.AdditionalConfiguration);
      formData.append('status', selectedConfiguration.Status);
      formData.append('description', selectedConfiguration.Description);
      formData.append('companyId', selectedConfiguration.CompanyID);
      formData.append('configurationId', selectedConfiguration.ConfigurationID);
      
      var url = '';
      if(selectedConfiguration.ConfigurationID !== "Nova")
        url = process.env.REACT_APP_BASE_URL + '/api/configuration/updateConfiguration';
      else
        url = process.env.REACT_APP_BASE_URL + '/api/configuration/insertConfiguration';

      await axios.postForm(url, selectedConfiguration);
      // Atualizar as configurações após a atualização bem-sucedida
      loadConfigurations();
      // Limpar a configuração selecionada e os campos de atualização
      setSelectedConfiguration('');
      setUpdatedConfiguration({});
    } catch (error) {
      console.error('Error updating configuration:', error);
    }
  };

  const insertSelected = async () => {
    setSelectedConfiguration({});
    setSelectedConfiguration((prevSelectedConfig) => ({
        ...prevSelectedConfig,
        ConfigurationID: 'Nova',
      }));
      setButtonName('Inserir');
  };

  const updateData = async (configuration) => {
    setSelectedConfiguration(configuration);
    setButtonName('Atualizar');
  };

 

  useEffect(() => {
    if(localStorage.getItem("user")===null)
    {
      window.location.href = "/";
      
    }
    else
    {
        // Carregar as configurações ao montar a página
        loadConfigurations();
    }
    
  }, []);

  // Função para lidar com as alterações nos campos do formulário de atualização
  

  return (
    <div className='container-fluid p-0'>
      <HeaderLogged></HeaderLogged>
      {/* <Menu></Menu> */}
      <div className="row showContentMargin" id='content'>
        <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
          <Sidebar></Sidebar>
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
    
    <div className="form-group center">
    <br></br>
    <br></br>
    <br></br>
    <button onClick={() => insertSelected()}>
                  Inserir Nova Configuração
                </button>
                </div>

      <table className='table'>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Json</th>
            <th>Configuração Adicional</th>
            <th>Status</th>
            <th>Descrição</th>
            <th>Empresa</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {configurations.map((configuration) => (
            <tr key={configuration.ConfigurationID}>
              <td>{configuration.Configuration}</td>
              <td className='break-word' style={{maxWidth:'300px',fontSize:'12px'}}>{configuration.OutputData}</td>
              <td style={{maxWidth:'300px',fontSize:'12px'}}>{configuration.AdditionalConfiguration}</td>
              <td>{configuration.Status}</td>
              <td>{configuration.Description}</td>
              <td>{configuration.CompanyID}</td>
              <td className="form-group center">
                <button onClick={() => updateData(configuration)}>
                  Selecionar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {selectedConfiguration && (
        <>
        <div className='form-group center'>
          <h2>{buttonName} dados</h2>
          <p>Configuração Selecionada: {selectedConfiguration.ConfigurationID}</p>
          <form >
            <label htmlFor="configuration">Nome:</label>
            <input
              type="text"
              id="configuration"
              name="configuration"
              value={selectedConfiguration.Configuration || ''}
              onChange={handleChangeConfiguration}
            />
            <label htmlFor="outputData">Json:</label>
            <input
              type="text"
              id="outputData"
              name="output_data"
              value={selectedConfiguration.OutputData || ''}
              onChange={handleChangeOutPut}
            />
            <label htmlFor="additionalConfiguration">Configuração Adicional:</label>
            <input
              type="text"
              id="additionalConfiguration"
              name="additional_configuration"
              value={selectedConfiguration.AdditionalConfiguration || ''}
              onChange={handleChangeAdditionalConfiguration}
            />
            <label htmlFor="status">Status:</label>
            <input
              type="text"
              id="status"
              name="status"
              value={selectedConfiguration.Status || ''}
              onChange={handleChangeStatus}
            />
            <label htmlFor="description">Descrição:</label>
            <input
              type="text"
              id="description"
              name="description"
              value={selectedConfiguration.Description || ''}
              onChange={handleChangeDescription}
            />
            <label htmlFor="companyId">Empresa:</label>
            <input
              type="text"
              id="companyId"
              name="companyID"
              value={selectedConfiguration.CompanyID || ''}
              onChange={handleChangeCompanyID}
            />
          </form>
          <div className="form-group center">
          <button onClick={updateConfiguration}>{buttonName}</button>
          </div>
          </div>
        </>
      )}
    </main>
      </div>
    </div>
  );
};

export default ConfigurationPage;